export default "__VITE_PUBLIC_ASSET__3de308c8__"